export const EAGER_LOAD_LISTINGS_COUNT = 2

export const MARKER_HOVER_CLASS_LIST = ['hover:cursor-pointer', 'hover:opacity-[0.85]']
